import ArticleResults from "./ArticleResults";

export default ArticleResults;
